import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_BASE_URL } from 'src/environments/environment';
import { AccessRule } from '../../components/access-control-rules/access-control-rules.component';

@Injectable({
  providedIn: 'root'
})
export class ApiAccessControlRulesService {

  constructor(private http: HttpClient) { }


   getAccessControlRules() {
       return this.http.get<AccessRule[]>(`${API_BASE_URL}/project/controllers/rkprules`);
      }

    getAccessControlRule(id) {
      return this.http.get<AccessRule>(`${API_BASE_URL}/project/controllers/rkprules/byid?id=${id}`);
    }

    updateAccessControlRule(accessRule: AccessRule) {
      return this.http.put(`${API_BASE_URL}/project/controllers/rkprules`,accessRule);
    }

    createNewAccessControlRule(accessRule: AccessRule) {
      return this.http.post(`${API_BASE_URL}/project/controllers/rkprules`,accessRule);
    }

    deleteAccessControlRule(id) {
        return this.http.delete(`${API_BASE_URL}/project/controllers/rkprules?id=${id}`);
    }

    getListOfRulesWithUserIdConditions() {
      return this.http.get<AccessRule[]>(`${API_BASE_URL}/project/controllers/rkprules/useridcondition`);
    }

    getActiveRulesForUser(userId: number) {
        return this.http.get<AccessRule[]>(`${API_BASE_URL}/project/controllers/rkprules/byuserId?userId=${userId}`);
    }

    updateActiveRulesForUser(requestBody: {userId: number, rulesIds: number[]  }) {
        return this.http.post(`${API_BASE_URL}/project/controllers/rkprules/updaterulesforuserbyruleid`, requestBody);
    }

}


